import { AVAILABLE_WEIGHT_TYPES } from './constants';

export function transformTypeToWeight(
  type?: keyof typeof AVAILABLE_WEIGHT_TYPES
) {
  return type && AVAILABLE_WEIGHT_TYPES.hasOwnProperty(type)
    ? AVAILABLE_WEIGHT_TYPES[type]
    : AVAILABLE_WEIGHT_TYPES['Regular'];
}
